import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -16","key":"svg-0"}]]

const IconColumns1 = createReactComponent('outline', 'columns-1', 'Columns1', __iconNode);

export default IconColumns1;